import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'

export default connect(
  {
    startIndex: state`startPage.startIndex`,
    onNextFiles: signal`startPage.onNextFiles`
  },
  class RightIcon extends Component {
    onNextClicked() {
      const { startIndex, onNextFiles, fileCount } = this.props
      if (fileCount > 0 && fileCount > startIndex + 5) {
        onNextFiles()
      }
    }

    render() {
      const { startIndex, fileCount } = this.props
      const color = fileCount <= startIndex + 5 ? '#efefef' : '#afafaf'
      const cursor = fileCount <= startIndex + 5 ? 'not-allowed' : 'pointer'

      return (
        <div className={css(styles.arrowWrapper)}>
          <svg
            className={css(styles.arrow)}
            style={{ cursor: cursor, right: -40 }}
            viewBox={'0 0 24 24'}
            fill={color}
            height={'48'}
            width={'48'}
            onClick={e => this.onNextClicked()}
          >
            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            <path d="M0-.25h24v24H0z" fill="none" />
          </svg>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/StartPage/Latest/icons/rightIcon.js